module.exports = __webpack_public_path__ + "img/Stephen.cc02cc94.jpg";